const resizeHandler = () => {
    const sHeight =  (window.visualViewport) ? window.visualViewport.height : window.innerHeight;
    let vh = sHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export default resizeHandler;